export default "__VITE_ASSET__BehYbgh8__"